import Vue from 'vue'
import axios from 'axios'
import { ApiError } from '@oit/api-error'
import { Message } from 'element-ui'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

function dataTransformer(data, header) {
  if (header['Content-Type']?.includes('multipart/form-data')) {
    return data
  }

  return {
    head: {
      aid: localStorage.getItem('userId'),
      cmd: header.cmd,
      ver: '1.0',
      ln: 'cn',
      mod: 'home',
      de: '2019-10-16',
      sync: 1,
      uuid: localStorage.getItem('roleId'),
      chcode: 'ef19843298ae8f2134f',
    },
    con: data ?? {},
  }
}

const defaultsTransformRequest = axios.defaults.transformRequest
axios.defaults.transformRequest = [
  dataTransformer,
  ...Array.isArray(defaultsTransformRequest)
    ? defaultsTransformRequest
    : (defaultsTransformRequest ? [defaultsTransformRequest] : []),
]

// 添加请求拦截器
axios.interceptors.request.use((config) => {
  config.headers.user_role_id = localStorage.getItem('roleId')
  config.headers.user_id = localStorage.getItem('userId')
  return config
}, (error) => {
  return Promise.reject(new ApiError({ error }))
})

// 添加响应拦截器
axios.interceptors.response.use((response) => {
  if (response.data.head && !(+response.data.head?.errorCode === 1 || +response.data.head?.httpStatus === 1)) {
    return Promise.reject(new ApiError({
      response,
      message: response?.data?.head?.msg,
      status: response?.data?.head?.httpStatus,
    }))
  }
  return response
}, async (error) => {
  return Promise.reject(new ApiError({ error }))
})

export function post(url, params = {}, config = {}) {
  return axios
    .post(url, params, config)
    .then(res => res.data)
}

Vue.config.errorHandler = (err, vm, info) => {
  // 处理接口错误
  if (err instanceof ApiError) {
    // 输出提示消息
    Message.error(err.message)
  }
  else {
    Vue.util.warn(err, vm)
  }
}
